import { render, staticRenderFns } from "./indexMain.vue?vue&type=template&id=401b05dc"
import script from "./indexMain.vue?vue&type=script&lang=js"
export * from "./indexMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports